import { initializeApp } from 'firebase/app'
import firebaseConfig from './firebaseConfig'

export default initializeApp(firebaseConfig)